import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import HashTag from './HashTag';
import HashTagInput from './HashTagInput'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';



const useStyles = makeStyles((theme) => ({
    tagholder:{
        paddingLeft: 20, 
        paddingRight: 20,
        display: 'inline'
    }
  }));

export default function HashTagHolder(props){
    const hashtags=props.hashtags
    const classes=useStyles();

    return(
        <Grid container>
            <Grid item xs={6} className={classes.tagholder} >
            <Typography style={{color: 'rgb(3 112 237)', marginLeft: '5px', fontSize: '14px'}}>
                Upvotes   
            </Typography>
                {hashtags.pos.map((upvote, idx)=>{
                    return(
                        <HashTag key={idx} hashtag={upvote} commentId={props.commentId} direction={'up'} changeHashtagVote={props.changeHashtagVote} />
                    )
                })}
                <HashTagInput direction={'up'} displayname={props.displayname} username={props.username} commentID={props.commentId} addHashtag={props.addHashtag} options={hashtags.pos.map((upvote, idx)=>{return(upvote.label)})}/> 
            </Grid>
            <Grid item xs={6}  className={classes.tagholder}>
            <Typography style={{color: 'rgb(220,50, 32)', marginLeft: '5px', fontSize: '14px'}}>
                Downvotes   
            </Typography>
                {hashtags.neg.map((downvote, idx)=>{
                    return(
                        <HashTag key={idx} hashtag={downvote} commentId={props.commentId} direction={'down'} changeHashtagVote={props.changeHashtagVote}/>
                    )
                })}
                <HashTagInput direction={'down'} displayname={props.displayname} username={props.username} commentID={props.commentId}  addHashtag={props.addHashtag} options={hashtags.neg.map((downvote, idx)=>{return(downvote.label)})}/> 
            </Grid>
        </Grid>
    )

}
